import { z } from 'zod';

export const VisualizationStatus = z.enum([
  'NotStarted',
  'Processing',
  'Failed',
  'Complete',
]);

export type VisualizationStatus = z.infer<typeof VisualizationStatus>;

export const PollVisualizerResponse = z.object({
  visualizationStatus: VisualizationStatus,
  link: z.string().optional(),
});

export type PollVisualizerResponse = z.infer<typeof PollVisualizerResponse>;
